import { useCallback } from 'react';
import { App } from 'antd';
import { forceStopSegment } from 'api/segment';
import { useI18n } from 'components/I18nProvider';
import { useEventAdminState } from 'components/EventStateProvider';
const isServerUnavailableError = (error) => (error instanceof TypeError && error.message === 'Failed to fetch')
    || error instanceof SyntaxError;
export const useFinishSegment = (eventId) => {
    const { intl } = useI18n();
    const { message } = App.useApp();
    const { setActionWaiting } = useEventAdminState();
    const finishSegment = useCallback(async (segmentId) => {
        setActionWaiting(true);
        try {
            await forceStopSegment(eventId, segmentId);
        }
        catch (error) {
            setActionWaiting(false);
            void message.error(intl.formatMessage({
                id: isServerUnavailableError(error) ? 'segmentFinishFailedNetwork' : 'segmentFinishFailed',
            }));
        }
    }, [eventId, intl, message, setActionWaiting]);
    return { finishSegment };
};
